import { Col, Flex, Row } from "antd";
import "./settings.css";
import AttributeView from "$attribute/AttributeView";
import AddAttributeModal from "$components/AddAttributeModal";
import RequiredAttributesField from "$components/RequiredAttributesField";
import DaysBlockChangeField from "$components/DaysBlockChangeField";
import ImportButton from "$components/ImportCSVButton";
import DeleteDataBase from "$components/DeleteWithAsking/DeleteDataBase";
import ExportButton from "../ExportButton";
import { useState } from "react";

const Settings = () => {
  const [isLoading, setLoadingComponent] = useState({
    export: false,
    import: false,
    delete: false,
  });
  return (
    <>
      <Flex justify="center" style={{ paddingBottom: "20px" }}>
        <Row gutter={[16, 16]}>
          <RequiredAttributesField text={"Anzahl korrekter Merkmale:"} />
          <DaysBlockChangeField text={"Fristsperre (d):"} />
        </Row>
        <Col span={10}>
          <Flex justify="flex-end" align="flex-start" gap="small">
            <ExportButton
              isLoading={isLoading}
              setLoadingComponent={setLoadingComponent}
            />
            <DeleteDataBase
              isLoading={isLoading}
              setLoadingComponent={setLoadingComponent}
            />
            <ImportButton
              isLoading={isLoading}
              setLoadingComponent={setLoadingComponent}
            />
            <AddAttributeModal />
          </Flex>
        </Col>
      </Flex>
      <AttributeView />
    </>
  );
};

export default Settings;
